export default __webpack_public_path__ + "static/media/top-social-overlay.1881e73c.svg";